import axios from 'axios'
import { errorHandler } from '../exports/error_management'

import { StorageCache } from '../exports/dataStorage'

const storageKey = 'ams-checkoff-type-key'

const api = async (method, path, params) => axios[method](path, params)

const sortTypes = (a, b) => {
    if (a.name.toUpperCase() > b.name.toUpperCase()) return 1
    else if (b.name.toUpperCase() > a.name.toUpperCase()) return -1
    else return 0
}

const state = {
    selectedType: {},
    types: [],
    notify_users: [],
      filter: '',
      work_flows : [],
}

const mutations = {
    SET_SELECTED_TYPE(state, data) {
        state.selectedType = data || {}
    },
    SET_TYPES(state, payload) {
        state.types = payload
    },
    SET_NULL_TYPE(state) {
        state.selectedType = {}
    },
    set_notify_users(state, payload){
        state.notify_users = payload
    },
    updateFilter(state, value) {
        state.filter = value;
    },
    SET_WORK_FLOW(state,value){
        state.work_flows = value;
    }
}

const actions = {
    async fetchWorkflow(context,type_id){
        try {
            const results = await api('post', `checkoff-template/checkoff-by-type`,{order_type_id:type_id})
            const data = results?.data?.success?.data;

            if (data) {
                context.commit('SET_WORK_FLOW', data);
            }
        } catch (err) {
            errorHandler(err)
        }
    },
    async clear_work_flow(context){
        context.commit('SET_WORK_FLOW', []);
    },
    async fetchAll(context) {
        try {
            const storageCache = new StorageCache(storageKey)
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const results = await api('get', `checkoff`)
                const data = results.data.success.data
                data.sort(sortTypes)
                console.log('checkoff all-new', data)
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            console.log('checkoff all', value)
            context.commit('SET_TYPES', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchAllAfterUpload(context) {
        try {
                const storageCache = new StorageCache(storageKey)
                const { value } = storageCache.getArray()
                const results = await api('get', `checkoff`)
                const data = results.data.success.data
                data.sort(sortTypes)
                console.log('checkoff all-new', data)
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            console.log('checkoff all', value)
            context.commit('SET_TYPES', value)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchById(context, id) {
        try {
            await context.dispatch('fetchAll')
            context.commit(
                'SET_SELECTED_TYPE',
                state.types.find(x => x.id == id)
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async create(context, payload) {
        try {
            const results = await api('post', `checkoff`, payload)
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('SET_SELECTED_TYPE', _data)
            storageCache.updateSelection(
                {
                    sortCompare: sortTypes,
                    selectionCommit,
                    stateList: context.state.types,
                },
                data,
                null
            )
            return data
        } catch (err) {
            errorHandler(err)
        }
    },

    async upload(context, payload) {
        try {
            const results = await api('post', `checkoff/upload`, payload)
            const data = results.data.success.data
            // const storageCache = new StorageCache(storageKey)
            // const selectionCommit = _data =>
            //     context.commit('SET_SELECTED_TYPE', _data)
            // storageCache.updateSelection(
            //     {
            //         sortCompare: sortTypes,
            //         selectionCommit,
            //         stateList: context.state.types,
            //     },
            //     data,
            //     data.id
            // )
            return data
        } catch (err) {
            errorHandler(err)
        }
    },
    
    async update(context, payload) {
        console.log('update', payload)
        try {
            const { id } = payload
            delete payload.id
            const results = await api('put', `checkoff/${id}`, payload)
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('SET_SELECTED_TYPE', _data)
            storageCache.updateSelection(
                {
                    sortCompare: sortTypes,
                    selectionCommit,
                    stateList: context.state.types,
                },
                data,
                id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        console.log("deletetypes");
        try {
            await api('delete', `checkoff/${id}`)
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('SET_SELECTED_TYPE', _data)
            storageCache.updateSelection(
                {
                    sortCompare: sortTypes,
                    selectionCommit,
                    stateList: context.state.types,
                },
                null,
                id
            )
        } catch (err) {
            console.log(err,"deletetypeserr");
            errorHandler(err)
        }
    },

    ////////////////////////////roles
    async createRole(context, { checkoff_type_id, role_id }) {
        try {
            const results = await api(
                'post',
                `checkoff/${checkoff_type_id}/roles`,
                { role_id }
            )
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('SET_SELECTED_TYPE', _data)
            storageCache.updateSelection(
                {
                    sortCompare: sortTypes,
                    selectionCommit,
                    stateList: context.state.types,
                },
                data,
                checkoff_type_id
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteRole(context, { checkoff_type_id, id }) {
        try {
            const results = await api(
                'delete',
                `checkoff/${checkoff_type_id}/roles/${id}`
            )
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('SET_SELECTED_TYPE', _data)
            storageCache.updateSelection(
                {
                    sortCompare: sortTypes,
                    selectionCommit,
                    stateList: context.state.types,
                },
                data,
                checkoff_type_id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async getUsersByReviewType(context, type_id) {
        try {
            const results = await api(
                'get',
                `checkoff-template/get-users-by-type/${type_id}`
            )
            const users = results.data.success.data
            context.commit('set_notify_users', users)
            return users
        } catch (err) {
            errorHandler(err)
        }
    },
    async getUsersByReviewTypeNew(context, type_id) {
        try {
            const results = await api(
                'get',
                `checkoff-template/get-users-by-type-new/${type_id}`
            )
            const users = results.data.success.data
            context.commit('set_notify_users', users)
            return users
        } catch (err) {
            errorHandler(err)
        }
    },
    async ExportExcel(context){
        try {
           
      
            const response =  await axios.get(`checkoff/export-excel`,{
                responseType: 'blob'
            });
            const blob = new Blob([response.data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "WorkFlows.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (err) {
            console.error("Error fetching request:", err);
          }

    },
    async exportExcelCSV(context, {query_w }) {
        try {
            query_w = query_w || '';
           
    
          const response = await  axios.get(`checkoff/export-excel-csv?q=${query_w}`,{
            responseType: 'blob'
        })
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "workflows.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error("Error fetching request:", err);
        }
      },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
